// extracted by mini-css-extract-plugin
module.exports = {"infomeetingCards":"event-cards-module--infomeeting-cards--2nZj1"};